<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>
    <div class="login">
      <div class="login-wrap">
        <div class="login_id-pass">
          <div class="login_input-box two-fac">
            <p class="login_two-fac_title">認証コード入力</p>
            <p class="login_two-fac_ex">
              メールアドレスへコードを送信しました。<br />コードを入力してください
            </p>

            <div class="login_two-fac_select">
              <p id="login_two-fac_input-name">認証コード</p>
              <input
                type="number"
                id="two-fac_input"
                name="name"
                required
                value
                v-model="formData.verify_code"
              />
              <p class="login_id-pass_lost-txt">
                届かないので<button
                  style="color: #3f71a0"
                  :style="{ color: this.canClick ? '#3f71a0' : 'gray' }"
                  @click="handleClick"
                  :disabled="!canClick"
                >
                  再送信する
                </button>
              </p>
              <p class="login_id-pass_lost-txt" v-show="waitTimeShow">
                {{this.waitTime}}秒後に認証コードを再取得できます
              </p>
            </div>
          </div>
          <van-button
            :disabled="!this.formData.verify_code"
            block
            :color="!this.formData.verify_code ? '#AACBE7' : '#48b2fb'"
            type="primary"
            native-type="submit"
            :loading="loading"
            @click="handleSure"
            id="pwd_btn_lost_code"
            >送信する</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {CheckVerifyCode, SendVerifyCode} from "@/services/user";
  import {Toast} from "vant";
  import "vant/es/toast/style";
  import Janus from "@/assets/js/janus";
  import Header from "@/components/Header.vue";

  export default {
  data() {
    return {
      password: "",
      user: JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)),
      formData: {},
      loading: false,
      canClick: true,
      waitTime: 60,
      waitTimeShow:false,

      mail:''
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.formData.id = this.user.id;
    this.mail = this.$route.query.mail;
  },
  methods: {
    onClickLeft() {
      history.back();
    },
    handleSure() {
      this.loading = true;
      const detail = this.formData;
      CheckVerifyCode(detail).then((res) => {
        if (res.data.code >= 0) {
          if (Janus) {
            Janus.videoPageDestory();
          }
          this.$router.push("/userPasswordUpdate");
        } else {
          let error_msg = "認証コードエラー";
          Toast.fail(error_msg);
          this.loading = false;
        }
      });
    },
    handleClick() {
      this.sendVerifyCode()
      this.canClick = false;
      this.waitTimeShow = true
      setTimeout(() => {
        this.canClick = true;
      }, 60000);
      let that = this
        that.waitTime--
        let timer = setInterval(function(){
          if(that.waitTime>1){
            that.waitTime--
          }else{
            clearInterval(timer)
            that.waitTime = 60
            that.waitTimeShow = false
          }
        },1000)
    },
    sendVerifyCode(){
      SendVerifyCode({mail:this.mail}).then((res)=>{
          if(res.data.code == 0) {
            Toast("送信成功")
          }else {
            Toast.fail("送信に失敗しました")
          }
      })
    }
  },
};
</script>

<style scoped>
   
   
  

#pwd_btn_lost_code {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
#pwd_btn_lost_code.possible {
  background: #3b82c4;
  pointer-events: auto;
}
.img-opacity {
  opacity: 0.4;
}
</style>
